// inputs.js
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TikTokIcon from "@mui/icons-material/MusicNote"; // No hay un icono específico, pero este se parece

import { validateRequired, validateLength, validateEmail, validateInteger, validateIntLength, validateNonZeroInteger, validatePhone, validateSelectInteger } from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    label: "Nombres de Empresa",
    name: "nombre_sitio",
    type: "text", // Cambié a "text" para poder hacer la validación manualmente
    placeholder: "Ingrese el nombre de la empresa",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 2, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 2,
    label: "Descripcion",
    name: "descripcion_sitio",
    type: "text",
    placeholder: "Ingrese la descripcion",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 2, maxLength: 500 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 3,
    label: "CUIT",
    name: "cuit_sitio",
    type: "text",
    placeholder: "Ingrese el CUIT",
    validation: (value, form) => {
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 2, maxLength: 500 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 4,
    label: "Domicilio",
    name: "domicilio_sitio",
    type: "text",
    placeholder: "Ingrese el domicilio",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 2, maxLength: 50 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 5,
    label: "Telefono",
    name: "telefonos_sitio",
    type: "text",
    placeholder: "Ingrese la descripcion",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const phoneError = validatePhone(value);
      if (phoneError) {
        return phoneError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 6,
    label: "Correo",
    name: "email_sitio",
    type: "text",
    placeholder: "Ingrese el correo",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de correo
      const emailError = validateEmail(value);
      if (emailError) {
        return emailError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 2, maxLength: 59 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 7,
    label: "Logo",
    name: "imagen_sitio",
    type: "file",
    accept: "image/png, image/jpeg",

  },
  {
    id: 8,
    label: "Vista de Panel de Articulos",
    name: "vista",
    type: "select",
    options: [
      { value: 'true', label: 'Cuadricula(PorDefecto)' },
      { value: 'false', label: 'Lista De Articulos ' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
  {
    id: 9,
    label: "Imagen Articulo",
    name: "imagen_articulo",
    type: "file",
    accept: "image/png, image/jpeg",
    placeholder: "",
  },
  {
    id: 10,
    label: "Retiro en Local",
    name: "retiro_local",
    type: "select",
    options: [
      { value: 'true', label: 'Visible' },
      { value: 'false', label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },{
    id: 11,
    label: "Entrega en Sucursal",
    name: "entrega_sucursal",
    type: "select",
    options: [
      { value: 'true', label: 'Visible' },
      { value: 'false', label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },{
    id: 12,
    label: "Opcion de Envio por Transporte",
    name: "envio_transporte",
    type: "select",
    options: [
      { value: 'true', label: 'Visible' },
      { value: 'false', label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
  {
    id: 13,
    label: "Codigo Postal",
    name: "codigoPostal",
    type: "number",
    placeholder: "Ingrese el codigo postal",
    validation: (value, form) => {
      if (form.envio_andreani === 'true') {
        const requiredError = validateNonZeroInteger(value);
        if (requiredError) {
          return "El código postal es obligatorio cuando el envío está habilitado.";
        }

        const intLengthError = validateIntLength(value, { minLength: 4, maxLength: 4 });
        if (intLengthError) {
          return intLengthError;
        }
      }

      return null;
    }
  },
  {
    id: 14,
    label: "Calle",
    name: "calle",
    type: "text",
    placeholder: "Ingrese la descripcion",
    validation: (value, form) => {
      if (form.envio_andreani === 'true') {
        const requiredError = validateRequired(value);
        if (requiredError) {
          return "La calle es obligatoria cuando el envío está habilitado.";
        }

        const lengthError = validateLength(value, { minLength: 2, maxLength: 40 });
        if (lengthError) {
          return lengthError;
        }
      }

      return null;
    }
  },
  {
    id: 15,
    label: "Numero",
    name: "numero",
    type: "number",
    placeholder: "Ingrese la numeracion del domicilio",
    validation: (value, form) => {
      if (form.envio_andreani === 'true') {
        const requiredError = validateNonZeroInteger(value);
        if (requiredError) {
          return "El número es obligatorio cuando el envío está habilitado.";
        }

        const intError = validateInteger(value);
        if (intError) {
          return intError;
        }
      }

      return null;
    }
  },
  {
    id: 16,
    label: "Provincia",
    name: "pcia_id",
    type: "select",
    validation: (value, form) => {
      if (form.envio_andreani === 'true') {
        // Si envio_andreani es true, entonces pcia_id es requerido
        const requiredError = validateNonZeroInteger(value);
        if (requiredError) {
          return "La provincia es obligatoria cuando el envío a domicilio está habilitado.";
        }
      }

      // Si no hay errores o no es requerido
      return null;
    }
  },
  {
    id: 17,
    label: "Localidad",
    name: "loc_id",
    type: "select",
    validation: (value, form) => {
      if (form.envio_andreani === 'true') {
        const requiredError = validateNonZeroInteger(value);
        if (requiredError) {
          return "La localidad es obligatoria cuando el envío a domicilio está habilitado.";
        }

      }

      // Si no es requerido o no hay errores
      return null;
    }
  },
  {
    id: 18,
    label: "Opción de Pago en el Local",
    name: "pagoLocalActivo",
    type: "select",
    defaultValue: 'true',
    options: [
      { value: 'true', label: 'Visible' },
      { value: 'false', label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
  {
    id: 19,
    label: "Opción de Transferencia",
    name: "pagoTransferenciaActivo",
    type: "select",
    defaultValue: 'true',
    options: [
      { value: 'true', label: 'Visible' },
      { value: 'false', label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
  {
    id: 20,
    label: "Opcion de Pago con Mercado Pago",
    name: "mercadoPagoActivo",
    type: "select",
    defaultValue: 'false',
    options: [
      { value: 'true', label: 'Visible' },
      { value: 'false', label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
  {
    id: 21,
    label: "Permitir Venta Sin Stock Disponible",
    name: "venta_sin_stock",
    defaultValue: 'false',
    type: "select",
    options: [
      { value: 'true', label: 'Permitir vender con stock negativo' },
      { value: 'false', label: 'No Permitir vender con stock negativo' },
    ],
    placeholder: "Seleccione una opción de venta",
  },
  {
    id: 22,
    label: "Monto Minimo de Compra",
    name: "monto_minimo",
    type: "number",
    defaultValue: 0,
    placeholder: "Ingrese el monto",
    validation: (value, form) => {
      if (value === undefined || value === null || value === '') {
        return 'Este campo es requerido';
      }

      const number = Number(value);
      if (isNaN(number)) {
        return 'Debe ser un número válido';
      }

      return null;
    }
  },
  {
    id: 23,
    label: "Facebook",
    name: "emp_facebook",
    type: "text",
    placeholder: "facebook.com/tuusuario",
    icon: <FacebookIcon style={{ color: "#1877F2" }} />, // Azul de Facebook
    formatValue: (value) => {
      if (!value) return ""; // Si está vacío, devolver vacío
      return !value.startsWith("facebook.com/") ? "facebook.com/" + value : value;
    },
    validation: (value) => {
      if (!value) return null; // No hay error si el campo está vacío
      if (!value.startsWith("facebook.com/")) return "El perfil debe comenzar con 'facebook.com/'";
      const username = value.replace("facebook.com/", "").trim();
      if (!/^[a-zA-Z0-9._-]+$/.test(username)) return "El usuario solo puede contener letras, números, '.' o '_'";
      if (username.length < 2 || username.length > 50) return "El usuario debe tener entre 2 y 50 caracteres";
      return null;
    }
  },
  {
    id: 24,
    label: "Instagram",
    name: "emp_instagram",
    type: "text",
    placeholder: "instagram.com/tuusuario",
    icon: <InstagramIcon style={{ color: "#E4405F" }} />, // Color rosa de Instagram
    formatValue: (value) => {
      if (!value) return ""; // Si está vacío, devolver vacío
      return !value.startsWith("instagram.com/") ? "instagram.com/" + value : value;
    },
    validation: (value) => {
      if (!value) return null; // No hay error si el campo está vacío
      if (!value.startsWith("instagram.com/")) return "El perfil debe comenzar con 'instagram.com/'";
      const username = value.replace("instagram.com/", "").trim();
      if (!/^[a-zA-Z0-9._-]+$/.test(username)) return "El usuario solo puede contener letras, números, '.' o '_'";
      if (username.length < 2 || username.length > 50) return "El usuario debe tener entre 2 y 50 caracteres";
      return null;
    }
  },
  {
    id: 25,
    label: "TikTok",
    name: "emp_tiktok",
    type: "text",
    placeholder: "tiktok.com/@tuusuario",
    icon: <TikTokIcon style={{ color: "#000" }} />, // Negro o rojo de TikTok
    formatValue: (value) => {
      if (!value) return ""; // Si está vacío, devolver vacío
      return !value.startsWith("tiktok.com/@") ? "tiktok.com/@" + value : value;
    },
    validation: (value) => {
      if (!value) return null; // No hay error si el campo está vacío
      if (!value.startsWith("tiktok.com/@")) return "El perfil debe comenzar con 'tiktok.com/@'";
      const username = value.replace("tiktok.com/@", "").trim();
      if (!/^[a-zA-Z0-9._-]+$/.test(username)) return "El usuario solo puede contener letras, números, '.' o '_'";
      if (username.length < 2 || username.length > 50) return "El usuario debe tener entre 2 y 50 caracteres";
      return null;
    }
  },
];

export default Inputs;
